import { adaptCategories } from './utils';

export const radiogroupConfig = [
  {
    name: 'isInReport:switch',
    displayName: 'Should question be visible in Report?',
    default: false,
    category: 'Reports',
  },

  {
    name: 'mainChart',
    displayName: 'Choose Main chart',
    choices: [
      'none',
      'bar-stacked',
      'bar-stacked-combined',
      'open-question',
      'bar',
      'bar-nps',
      'activation',
      'statements-bar-raw',
    ],
    default: 'none',
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport;
    },
    onSetValue: (obj: any, value: string) => {
      if (value === 'bar-stacked-combined') {
        obj.secondaryChart = 'open-question-stacked-combined';
      }
      obj.setPropertyValue('mainChart', value);
    },
    dependsOn: ['isInReport'],
  },
  {
    name: 'customZeroAnswersLabel:shortText',
    default: '',
    displayName: 'Type custom 0% answers label',
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport && obj.mainChart === 'statements-bar';
    },
    isLocalizable: true,
    dependsOn: ['isInReport', 'mainChart'],
  },
  {
    name: 'secondaryChart',
    default: 'none',
    displayName: 'Choose Secondary chart',
    choices: ['none', 'open-question', 'bar', 'bar-nps', 'bar-detailed'],
    category: 'Reports',
    visibleIf: function (obj: any) {
      const exceptions = ['none', 'activation', 'bar-stacked-combined'];
      return obj.isInReport && !exceptions.includes(obj.mainChart);
    },
    dependsOn: ['isInReport', 'mainChart'],
  },
  {
    name: 'isCollapsable:switch',
    displayName: 'is Collapsable display?',
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport && obj.secondaryChart !== 'none';
    },
    dependsOn: ['isInReport', 'secondaryChart'],
  },
  {
    name: 'isOtherTextOverriden:switch',
    displayName: 'Override other choice text?',
    default: false,
    isLocalizable: true,
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport && obj.mainChart === 'bar-stacked-combined';
    },
    dependsOn: ['isInReport', 'mainChart'],
  },
  {
    name: 'isSentimentLabelsOverridden:switch',
    displayName: 'Override sentiment labels?',
    default: false,
    category: 'Sentiment labels',
  },
  {
    name: 'dontKnowText',
    displayName: 'Dont know text',
    default: false,
    category: 'Dont know',
  },
  {
    name: 'dontKnowValue',
    displayName: 'Dont know value',
    category: 'Dont know',
  },
  {
    name: 'otherReportLabel:shorttext',
    displayName: 'Label for other choice in report',
    isLocalizable: true,
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport && obj.mainChart === 'bar-stacked-combined';
    },
    dependsOn: ['isInReport', 'mainChart'],
  },
  {
    name: 'overridenOtherText',
    displayName: 'Other text',
    isLocalizable: true,
    category: 'Reports',
    visibleIf: function (obj: any) {
      return (
        obj.isInReport &&
        obj.mainChart === 'bar-stacked-combined' &&
        obj.isOtherTextOverriden
      );
    },
    dependsOn: ['isInReport', 'mainChart', 'isOtherTextOverriden'],
  },
  {
    name: 'activationText',
    default:
      'Put tool specific activation text, that will be visible in reports',
    isLocalizable: true,
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport && obj.mainChart === 'activation';
    },
    dependsOn: ['isInReport', 'mainChart'],
  },
  {
    name: 'activationTooltip',
    default:
      'Put tool specific activation tooltip, that will be visible in reports',
    isLocalizable: true,
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport && obj.mainChart === 'activation';
    },
    dependsOn: ['isInReport', 'mainChart'],
  },
  {
    name: 'involvementText',
    default:
      'Put tool specific involvement text, that will be visible in reports',
    isLocalizable: true,
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport && obj.mainChart === 'activation';
    },
    dependsOn: ['isInReport', 'mainChart'],
  },
  {
    name: 'involvementTooltip',
    default:
      'Put tool specific involvement tooltip, that will be visible in reports',
    isLocalizable: true,
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport && obj.mainChart === 'activation';
    },
    dependsOn: ['isInReport', 'mainChart'],
  },
  {
    name: 'activatedTooltip',
    default:
      'Put tool specific activated tooltip, that will be visible in reports',
    isLocalizable: true,
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport && obj.mainChart === 'activation';
    },
    dependsOn: ['isInReport', 'mainChart'],
  },
  {
    name: 'involvedTooltip',
    default:
      'Put tool specific involved tooltip, that will be visible in reports',
    isLocalizable: true,
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport && obj.mainChart === 'activation';
    },
    dependsOn: ['isInReport', 'mainChart'],
  },
  {
    name: 'neutralTooltip',
    default:
      'Put tool specific neutral tooltip, that will be visible in reports',
    isLocalizable: true,
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport && obj.mainChart === 'activation';
    },
    dependsOn: ['isInReport', 'mainChart'],
  },
  {
    name: 'unclassifiedTooltip',
    default:
      'Put tool specific unclassified tooltip, that will be visible in reports',
    isLocalizable: true,
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport && obj.mainChart === 'activation';
    },
    dependsOn: ['isInReport', 'mainChart'],
  },
  {
    name: 'mainCategory',
    default: 'none',
    displayName: 'Choose Main category',
    choices: function (obj: any) {
      const { reportCategories } = obj.survey;

      if (reportCategories) {
        return ['none', ...adaptCategories(reportCategories.categories)] || [];
      }

      return [];
    },
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport;
    },
    dependsOn: ['isInReport'],
  },
  {
    name: 'secondaryCategory',
    default: 'none',
    displayName: 'Choose Secondary category',
    choices: function (obj: any) {
      const { reportCategories } = obj.survey;

      if (reportCategories) {
        return (
          ['none', ...adaptCategories(reportCategories.subcategories)] || []
        );
      }

      return [];
    },
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport;
    },
    dependsOn: ['isInReport'],
  },
];
